<template>
    <header class="main-header">
        <!-- Header Navbar -->
        <nav class="navbar navbar-expand" :class="appLayout.nav">
            <!-- Sidebar toggle button-->
            <ul class="navbar-nav">
                <li class="nav-item"><a class="nav-link" data-widget="pushmenu" href="#"><i class="fa fa-bars"></i></a>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto">
                <li v-if="auth_user" class="nav-item dropdown">
                    <a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="true">
                        <i class="fa fa-bell"></i>
                        <span class="badge badge-warning navbar-badge">{{auth_user.notifications_count}}</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px;">
                        <span class="dropdown-item dropdown-header">{{auth_user.notifications_count}}
                            Notificaticações</span>
                        <template v-for="(item, i) in auth_user.notifications">
                        <div class="dropdown-divider" :key="i+'divider'"></div>
                            <a href="#" class="dropdown-item" :key="i">
                                <i class="fa fa-check mr-2"></i> {{item.title.slice(0, 15)}}
                                <span class="float-right text-muted text-sm">{{item.created_at}}</span>
                            </a>
                        </template>
                        <div class="dropdown-divider"></div>
                        <router-link to="/notifications" role="button" class="dropdown-item dropdown-footer">
                        Ver mais
                    </router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <router-link to="/profile" role="button" class="nav-link">
                        <i class="fa fa-user"></i> Conta
                    </router-link>
                </li>
                <li @click="signOut" class="nav-item">
                    <a href="#" role="button" class="nav-link">
                        <i class="fa fa-sign-out"></i> {{$t('words.log_out')}}
                    </a>
                </li>
            </ul>
        </nav>
    </header>
</template>

<script>
    /*eslint no-mixed-spaces-and-tabs: [2, "smart-tabs"]*/
    import moment from 'moment';
    export default {
        props: {
            user: Object
        },
        computed: {
            registered_at() {
                return moment(this.user.created_at).format('MMM/YYYY');
            },
        },
        methods: {
            signOut() {
                $('#ModalLogout').modal('toggle');
            },
            showNotification(notification, id) {
                if (!notification.is_previewed)
                    this.$store
                    .dispatch('previewNotification', notification.id)
                    .then(response => {
                        response.index = id;
                        this.$store.dispatch('setNotification', response);
                    });

            }
        }
    };
</script>

<style scoped>
    ul.dropdown-menu {
        cursor: default !important;
    }

    .text-underline {
        text-decoration: underline;
    }
</style>